import React from 'react';
import styled from 'styled-components';
import {useDispatch} from 'react-redux';

import Toast from '../../../CoreWrappers/Toast';
import {
	raiseInformationMessage,
	raiseJSValidationError,
	raiseSuccessMessage,
	raiseWarningMessage
} from '../../../../actions/erroractions';

const ToastDrydock = () => {
	const dispatch = useDispatch();

	const handleRaiseNotification = (type = 'error') => (e) => {
		e.preventDefault();
		if (type === 'info') dispatch(raiseInformationMessage('This is an INFO Message'));
		if (type === 'error') dispatch(raiseJSValidationError('This is an ERROR Message'));
		if (type === 'warning') dispatch(raiseWarningMessage('This is a WARNING Message'));
		if (type === 'success') dispatch(raiseSuccessMessage('This is a SUCCESS Message'));
	};

	return (
		<StyledToastDrydock className="full">
			<Toast
				message="You have access to the EY Canvas Oversight projects listed here. Select a module to navigate to it or click on a count to see details for each of your projects."
				actions={[{text: 'Raise Notification', onClick: handleRaiseNotification('info')}]}
			/>
			<Toast
				message="You have access to the EY Canvas Oversight projects listed here. Select a module to navigate to it or click on a count to see details for each of your projects."
				variant="error"
				actions={[{text: 'Raise Notification', onClick: handleRaiseNotification('error')}]}
			/>
			<Toast
				message="You have access to the EY Canvas Oversight projects listed here. Select a module to navigate to it or click on a count to see details for each of your projects."
				variant="warning"
				actions={[{text: 'Raise Notification', onClick: handleRaiseNotification('warning')}]}
			/>
			<Toast
				message="You have access to the EY Canvas Oversight projects listed here. Select a module to navigate to it or click on a count to see details for each of your projects."
				variant="success"
				actions={[{text: 'Raise Notification', onClick: handleRaiseNotification('success')}]}
			/>
		</StyledToastDrydock>
	);
};

export default ToastDrydock;

const StyledToastDrydock = styled.div`
	display: flex;
	flex-direction: column;
	gap: inherit;
`;
